import { useEffect, useRef } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};

export const useHasChanged = <T>(value: T): boolean => {
  const prevVal = usePrevious(value);
  return prevVal !== value;
};
